<template>
  <v-list dense style="border: 1px solid;">
    <v-subheader>
      <v-layout class="justify-space-between align-end">
        <span class="tw-font-extrabold">{{ $page.props.user.name }}</span>
        <v-btn small outlined @click="logout" color="error" text>Logout</v-btn>
      </v-layout>
    </v-subheader>
    <v-list-item link :href="route('profile.show')" @click.stop.prevent="goTo(route('profile.show'))" two-line>
      <v-list-item-avatar>
        <v-img :src="$user.profile_photo_url"></v-img>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>View Profile</v-list-item-title>
        <v-list-item-subtitle>Change password, enable 2FA, etc</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item @click="_changeMode()" title="Toggle Dark Mode" two-line v-if="!$breakpoint.smAndUp">
      <v-list-item-icon>
        <v-icon>mdi-theme-light-dark</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>Toggle Dark Mode</v-list-item-title>
        <v-list-item-subtitle>Change between dark mode and light mode</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item link v-if="$page.props.jetstream.canCreateTeams">
      <v-list-item-content>
        <inertia-link :href="route('teams.create')">Create New Team</inertia-link>
      </v-list-item-content>
    </v-list-item>
    <v-list-item link href="/service_requests/create" @click.stop.prevent="goTo('/service_requests/create')" title="Request Service">
      <v-list-item-icon>
        <v-icon color="">mdi-thermometer-plus</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>Request Service</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item link href="/user/professional" @click.stop.prevent="goTo('/user/professional')" title="Professional profile">
      <v-list-item-icon>
        <v-icon color="">mdi-account-tie</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ $user.professional_count == 1 ? 'Professional Profile' : 'Create professional profile' }}</v-list-item-title>
        <v-list-item-subtitle>For medical professionals</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item link href="/user/client" @click.stop.prevent="goTo('/user/client')" title="Client profile">
      <v-list-item-icon>
        <v-icon color="">mdi-account-group</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ $user.client_count == 1 ? 'Client profile' : 'Create client profile' }}</v-list-item-title>
        <v-list-item-subtitle>To request medical services</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item link href="/settings" @click.stop.prevent="goTo('/settings')" title="Admin" v-if="$admin">
      <v-list-item-icon>
        <v-icon color="red">mdi-cogs</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>System Settings</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item link href="/admin" @click.stop.prevent="goTo('/admin')" title="Admin" v-if="$admin">
      <v-list-item-icon>
        <v-icon color="red">security</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>Admin</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
  import Vue from 'vue'
  import VueCookie from 'vue-cookie'

  Vue.use(VueCookie)

  export default {
    name: 'UserMenu',
    methods: {
      logout () {
        this.$cookie.set('loggedout', true, { expires: '1D' })
        this.$inertia.post('/logout')
      }
    },
  }
</script>
